/*
 * 报价管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';

export default {
  path: 'billing',
  name: 'BusinessBilling',
  component: EmptyRouterAlive,
  meta: {
    title: '账单管理',
  },
  children: [
    {
      path: 'invoiceReview',
      name: 'BusinessBillingInvoiceReview',
      component: EmptyRouter,
      redirect: 'invoiceReview/index',
      meta: { title: 'Invoice Review' },
      children: [{
        path: 'index',
        name: 'BusinessBillingInvoiceReview',
        component: () => import('@/views/center-business/billing/invoiceReview'),
        meta: { title: 'Invoice Review', isCache: false },
      }],
    },
    {
      path: 'price',
      name: 'BusinessBillingPrice',
      component: EmptyRouter,
      redirect: 'price/index',
      meta: {
        title: '客户报价单',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingPrice',
          component: () => import('@/views/center-business/billing/price'),
          meta: {
            title: '客户报价单',
            isCache: true,
          },
        },
      ],
    },
    {
      path: 'ServiceInvoices',
      name: 'BusinessBillingServiceInvoices',
      component: EmptyRouter,
      redirect: 'ServiceInvoices/index',
      meta: {
        title: '客户账单',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingServiceInvoices',
          component: () => import('@/views/center-business/billing/ServiceInvoices'),
          meta: {
            title: '客户账单',
            isCache: true,
          }
        },
      ],
    },
    // Admin端
    {
      path: 'categories',
      name: 'BusinessBillingCategories',
      component: EmptyRouter,
      redirect: 'categories/index',
      meta: {
        title: '账单分类',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingCategories',
          component: () => import('@/views/center-business/billing/categories'),
          meta: {
            title: '账单分类',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'ProfileTemplates',
      name: 'BusinessBillingProfileTemplates',
      component: EmptyRouter,
      redirect: 'ProfileTemplates/index',
      meta: {
        title: '账单配置文件模板',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingProfileTemplates',
          component: () => import('@/views/center-business/billing/ProfileTemplates'),
          meta: {
            title: '账单配置文件模板',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'ClientProfiles',
      name: 'BusinessBillingClientProfiles',
      component: EmptyRouter,
      redirect: 'ClientProfiles/index',
      meta: {
        title: '客户端配置文件',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingClientProfiles',
          component: () => import('@/views/center-business/billing/ClientProfiles'),
          meta: {
            title: '客户端配置文件',
            isCache: false,
          }
        },
      ],
    },
    {
      path: 'Transactions',
      name: 'BusinessBillingTransactions',
      component: EmptyRouter,
      redirect: 'Transactions/index',
      meta: {
        title: '账单业务',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingTransactions',
          component: () => import('@/views/center-business/billing/Transactions'),
          meta: {
            title: '账单业务',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'Deposit',
      name: 'BusinessBillingDeposit',
      component: EmptyRouter,
      redirect: 'Deposit/index',
      meta: {
        title: '钱包',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingDeposit',
          component: () => import('@/views/center-business/billing/deposit'),
          meta: { title: '钱包', isCache: true },
        },
        {
          path: 'info',
          name: 'BusinessBillingDeposiInfo',
          component: () => import('@/views/center-business/billing/deposit/components/info'),
          meta: { title: '钱包信息', isCache: true },
        },
      ],
    },
    {
      path: 'MyDeposit',
      name: 'BusinessBillingMyDeposit',
      component: EmptyRouter,
      redirect: 'MyDeposit/index',
      meta: {
        title: '我的钱包',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingMyDeposit',
          component: () => import('@/views/center-business/billing/myDeposit'),
          meta: { title: '我的钱包' },
        }
      ],
    },
    {
      path: 'clientAccounts',
      name: 'BusinessBillingClientAccounts',
      component: EmptyRouter,
      redirect: 'clientAccounts/index',
      meta: {
        title: '客户账户信息',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingClientAccounts',
          component: () => import('@/views/center-business/billing/clientAccounts'),
          meta: { title: '客户账户信息' },
        }
      ],
    },
    {
      path: 'CustomerInventoryPricing',
      name: 'BusinessBillingCustomerInventoryPricing',
      component: EmptyRouter,
      redirect: 'CustomerInventoryPricing/index',
      meta: {
        title: '客户库存计费',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingCustomerInventoryPricing',
          component: () => import('@/views/center-business/billing/CustomerInventoryPricing'),
          meta: { title: '客户库存计费' },
        }
      ],
    },
    {
      path: 'CostExpenditureStatistics',
      name: 'BusinessBillingCostExpenditureStatistics',
      component: EmptyRouter,
      redirect: 'CostExpenditureStatistics/index',
      meta: {
        title: '成本支出统计',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingCostExpenditureStatistics',
          component: () => import('@/views/center-business/billing/CostExpenditureStatistics'),
          meta: { title: '成本支出统计' },
        }
      ],
    },
    {
      path: 'CostItem',
      name: 'BusinessBillingCostItem',
      component: EmptyRouter,
      redirect: 'CostItem/index',
      meta: {
        title: '成本项',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingCostItem',
          component: () => import('@/views/center-business/billing/CostItem'),
          meta: { title: '成本项' },
        }
      ],
    },
    {
      path: 'previewInvoices',
      name: 'BusinessBillingPreviewInvoices',
      component: EmptyRouter,
      redirect: 'previewInvoices/index',
      meta: {
        title: '账单预览',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingPreviewInvoices',
          component: () => import('@/views/center-business/billing/previewInvoices'),
          meta: {
            title: '账单预览',
            isCache: false,
          }
        },
      ],
    },
    {
      path: 'invoices',
      name: 'BusinessBillingInvoices',
      component: EmptyRouter,
      redirect: 'invoices/index',
      meta: {
        title: '账单',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingInvoices',
          component: () => import('@/views/center-business/billing/invoices'),
          meta: {
            title: '账单',
            isCache: false,
          }
        },
      ],
    },
    {
      path: 'additionalCharge',
      name: 'BusinessBillingAdditionalCharge',
      component: EmptyRouter,
      redirect: 'additionalCharge/index',
      meta: {
        title: '增值服务',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingAdditionalCharge',
          component: () => import('@/views/center-business/billing/additionalCharge'),
          meta: {
            title: '增值服务',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'Credit',
      name: 'BusinessBillingCredit',
      component: EmptyRouter,
      redirect: 'Credit/index',
      meta: {
        title: '信用票据',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingCredit',
          component: () => import('@/views/center-business/billing/Credit'),
          meta: {
            title: '信用票据',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'Historical',
      name: 'BusinessBillingHistorical',
      component: EmptyRouter,
      redirect: 'Historical/index',
      meta: {
        title: '成本列表',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingHistorical',
          component: () => import('@/views/center-business/billing/Historical'),
          meta: {
            title: '成本列表',
            isCache: true,
          }
        },
        {
          path: 'history',
          name: 'BusinessBillingHistoricaCost',
          component: () => import('@/views/center-business/billing/Historical/history'),
          meta: {
            title: '历史成本',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'Expense',
      name: 'BusinessBillingExpense',
      component: EmptyRouter,
      redirect: 'Expense/index',
      meta: {
        title: '开支管理',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingExpense',
          component: () => import('@/views/center-business/billing/Expense'),
          meta: {
            title: '开支管理',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'regularSurcharge',
      name: 'BusinessBillingRegularSurcharge',
      component: EmptyRouter,
      redirect: 'regularSurcharge/index',
      meta: {
        title: '增收费',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingRegularSurcharge',
          component: () => import('@/views/center-business/billing/regularSurcharge'),
          meta: {
            title: '增收费',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'invoiceStatement',
      name: 'BusinessBillingInvoiceStatement',
      component: EmptyRouter,
      redirect: 'invoiceStatement/index',
      meta: {
        title: '结账清单',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingInvoiceStatement',
          component: () => import('@/views/center-business/billing/invoiceStatement'),
          meta: {
            title: '结账清单',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'shippingCharges',
      name: 'BusinessBillingShippingCharges',
      component: EmptyRouter,
      redirect: 'shippingCharges/index',
      meta: {
        title: '装运费',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingShippingCharges',
          component: () => import('@/views/center-business/billing/shippingCharges'),
          meta: {
            title: '装运费',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'storageReport',
      name: 'BusinessBillingStorageReport',
      component: EmptyRouter,
      redirect: 'storageReport/index',
      meta: {
        title: '存储报告',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingStorageReport',
          component: () => import('@/views/center-business/billing/storageReport'),
          meta: {
            title: '存储报告',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'reportTab',
      name: 'BusinessBillingInvoiceReport',
      component: EmptyRouter,
      redirect: 'reportTab/index',
      meta: {
        title: '发票报表',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingInvoiceReport',
          component: () => import('@/views/center-business/billing/reportTab/index'),
          meta: {
            title: 'total',
            isCache: true,
          },
        },
      ],
    },
    {
      path: 'TierSetting',
      name: 'BusinessBillingTierSetting',
      component: EmptyRouter,
      redirect: 'TierSetting/index',
      meta: {
        title: '档位配置',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingTierSetting',
          component: () => import('@/views/center-business/billing/TierSetting'),
          meta: {
            title: '档位配置',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'operationLog',
      name: 'BusinessBillingOperationLog',
      component: EmptyRouter,
      redirect: 'operationLog/index',
      meta: {
        title: '操作日志',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingOperationLog',
          component: () => import('@/views/center-business/billing/operationLog/index'),
          meta: {
            title: 'total',
            isCache: true,
          },
        },
      ],
    },
    {
      path: 'postage',
      name: 'BusinessBillingPostage',
      component: EmptyRouter,
      redirect: 'postage/index',
      meta: {
        title: '邮费对比',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingPostage',
          component: () => import('@/views/center-business/billing/postage/index'),
          meta: {
            title: '邮费对比',
            isCache: true,
          },
        },
        {
          path: 'detail',
          name: 'BusinessOrderPostagDetail',
          component: () => import('@/views/center-business/billing/postage/detail'),
          meta: {
            title: '邮费对比详情',
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'PostageRecharge',
      name: 'BusinessBillingPostageRecharge',
      component: EmptyRouter,
      redirect: 'PostageRecharge/index',
      meta: {
        title: '运费补收',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBillingPostageRecharge',
          component: () => import('@/views/center-business/billing/PostageRecharge/index'),
          meta: {
            title: '运费补收',
            isCache: true,
          },
        }, {
          path: 'PostageRechargeDetail',
          name: 'BusinessBillingPostageRechargeDetail',
          component: () => import('@/views/center-business/billing/PostageRecharge/detail'),
          meta: {
            title: '运费补收详情',
            isCache: true,
          },
          hidden: true,
        },
      ],
    },

  ],
};
